import { ReactNode } from 'react';
import style from './blocker.module.less';


export default function Blocker(props: { children: ReactNode; }) {
  return <div data-exam-border className={style.blc}>{props.children}</div>;
}
